import type { KeySignatureDisplay } from 'Seeds/ExerciseContent/scaleNotation';
import { createPerUserDeviceStore } from 'Settings/perUserDeviceStore';
import { normalizeKeySignatureDisplay } from './keySignatureDisplaySettings';

/**
 * The setting lives in the per-user namespace of the app's persisted storage
 * (`<user id>-museflow_key_signature_display`), so each account on a device keeps
 * its own. It is a device preference, not account data: sign-out carries it
 * through its storage clear (see `isKeySignatureDisplayStorageKey`). The store
 * itself is the settings model's per-user device store; this file names it.
 */
export const KEY_SIGNATURE_DISPLAY_STORAGE_KEY = 'museflow_key_signature_display';

export const keySignatureDisplayStore = createPerUserDeviceStore<KeySignatureDisplay>({
  storageKey: KEY_SIGNATURE_DISPLAY_STORAGE_KEY,
  decode: normalizeKeySignatureDisplay,
  encode: (display) => display,
  errorTag: 'keySignatureDisplay.load',
});

/** Whether a full storage key (any user prefix included) holds the setting. */
export const isKeySignatureDisplayStorageKey = keySignatureDisplayStore.isStorageKey;

/** A user's saved setting, or the default when none is saved or readable. */
export const loadKeySignatureDisplay = keySignatureDisplayStore.load;

export const saveKeySignatureDisplay = keySignatureDisplayStore.save;
